export const buildInfo = {
    cameraFramesVersion: 'v3.0.0',
    timestamp: 1789250515,
    version: 'v3.0.0-1789250515'
};
